import React from 'react'
import GroupBuyingTable from "./components/GroupBuyingTable"
import {useGroupBuyingContext} from "./store/useGroupBuyingContext"
import {Card, Result, Skeleton, Space} from "antd"
import GroupBuyingOpen from "./components/GroupBuyingOpen"
import GroupBuyingAdd from "./components/GroupBuyingAdd"
import GroupBuyingVerification from './components/GroupBuyingVerification'

const GroupBuyingLayout = () => {
    const {grouponListState, grouponSettingState} = useGroupBuyingContext()
    if (grouponListState.isLoading || grouponSettingState.isLoading) {
        return <Skeleton active/>
    }

    if (grouponListState.error) {
        return (
            <Result
                status="error"
                title="获取团购列表失败"
                subTitle={grouponListState.error.message}
            />
        )
    }

    return (
        <div>
            <div style={{height: "100%"}}>
                <Card
                    title={"团购列表"}
                    extra={grouponSettingState.data.useGroupon &&
                        <Space>
                            <GroupBuyingVerification/>
                            <GroupBuyingOpen/>
                            <GroupBuyingAdd/>
                        </Space>
                    }
                >
                    {grouponSettingState.data.useGroupon ?
                        <GroupBuyingTable/> :
                        <div style={{display: "flex", alignItems: "center", justifyContent: "center", height: "100%"}}>
                            <Result
                                title="你已经关闭团购功能，无法查看团购列表"
                                subTitle={"请点击开启团购按钮，开启团购功能"}
                                extra={
                                    <GroupBuyingOpen/>
                                }
                            />
                        </div>}
                </Card>
            </div>
        </div>
    )
}

export default GroupBuyingLayout


// WEBPACK FOOTER //
// ./src/containers/GroupBuyingList/layout.js